import React from "react";
import styles from "./HeroSection.module.css";
import Leader from "../../Assets/Leader.png";
import Line from "../../Assets/Vector.png";
import APK from "../../Assets/Apk.png";
import hand from "../../Assets/frame90.png";
import googlebutton from "../../Assets/googleplay.png";
import appstorebutton from "../../Assets/appstore.png";
import logo from "../../Assets/Logo.png";

const HeroSection = () => {
  const APK_DOWNLOAD_URL = process.env.REACT_APP_APK_DOWNLOAD_URL;
  //  const APK_DOWNLOAD_URL = 'https://maquickscannerappwebsite.blob.core.windows.net/maquickscannerwebpage-container/Dear-Lottery.apk?sp=r&st=2025-08-13T03:57:06Z&se=2030-07-06T12:12:06Z&spr=https&sv=2024-11-04&sr=b&sig=zgl%2Fy6RY7mGRGkt2T0iVE2cMQ7qX3RrMVJR1suVd8F0%3D' ;
  console.log(APK_DOWNLOAD_URL);
  return (
    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <img src={logo} alt="ss" className={styles.logo} />

        <p>
          Stay updated with crisp, reliable news and viral videos — all in one
          simple and powerful app. SS Media delivers top news and trending
          videos and real-time reactions from users like you in English and
          Tamil, ensuring you never miss what matters most.
        </p>
        <div className={styles.divi}>
          <h6>Available Soon</h6>
          {/* <div className={styles.divider}></div> */}
          <img src={Line} style={{paddingBottom:'2rem'}}/>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              width: "3rem",
              height: "3rem",
              gap: "2rem",
              paddingRight: "15rem",
            }}
          >
            <img src={googlebutton} />
            <img src={appstorebutton} />
          </div>
        </div>
      </div>
      <div className={styles.handimage}>
        <img src={hand} alt="Hand" />
      </div>
    </section>
  );
};

export default HeroSection;
